import getBannerWebRow from "../DataDisplayRow/BannerWebRow";
import DataDisplayRowI from "../DataDisplayRowI";
import DataDisplayTable from "../DataDisplayTable";

class BannerWebTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getBannerWebRow()
    }
}

let bannerWebTable: BannerWebTable | null = null;

export default function getBannerWebTable(): BannerWebTable {
    if (bannerWebTable === null)
        bannerWebTable = new BannerWebTable()
    return bannerWebTable
}